// O "Preço de Custo" do card do pedido (Adnéia, 27/10/2026: "Venda; se zero, últ. compra").
// O card mostra o custo de uma unidade gravado na venda (cmv, v_elo_tabelao). Quando ele vem
// zerado ou vazio, mostra o custo da última compra do SKU (precos_compra_hist, a mesma fonte
// do Buscar Produto e de Cancelamentos, rota /cancelamentos/custo-skus), com esse nome.
// Por quê: a regra da devolução usa o custo (defeito do fornecedor só volta por devolução
// acima de R$ 50,00). Em 27/10, um faqueiro Tramontina (TINA10306) vendido a R$ 219,90 tinha
// "Preço de Custo: R$ 0.00" no card e R$ 153,84 de última compra: pelo card, seria reenviado
// sem a devolução.

// '153.84' / 153.84 -> 153.84; vazio, zero, negativo ou texto -> 0 (custo que não vale).
export function valorDeCusto(valor) {
  if (valor === null || valor === undefined) return 0;
  const n = typeof valor === 'number' ? valor : parseFloat(String(valor).trim().replace(',', '.'));
  return Number.isFinite(n) && n > 0 ? n : 0;
}

function skuDoCard(pedidoErp) {
  return String(pedidoErp?.codigo_item_vtex || '').trim().toUpperCase();
}

// Só se lê a última compra quando o custo da venda não vale e o card tem SKU.
export function precisaUltimaCompra(pedidoErp) {
  return !!skuDoCard(pedidoErp) && valorDeCusto(pedidoErp?.cmv) === 0;
}

// ultimaCompra vem guardada com o SKU consultado ({sku, valor} ou {sku, falhou: true}):
// resposta de outro SKU (o card de antes) vale como "consultando", para não mostrar o
// custo de outro produto.
// fonte: 'venda' | 'ultima_compra' | 'consultando' | 'falhou' | 'sem_custo' (valor null = "?").
export function custoDoCard(pedidoErp, ultimaCompra) {
  const venda = valorDeCusto(pedidoErp?.cmv);
  if (venda > 0) return { rotulo: 'Preço de Custo', valor: venda, fonte: 'venda' };
  const sku = skuDoCard(pedidoErp);
  if (!sku) return { rotulo: 'Preço de Custo', valor: null, fonte: 'sem_custo' };
  if (!ultimaCompra || ultimaCompra.sku !== sku) return { rotulo: 'Preço de Custo', valor: null, fonte: 'consultando' };
  if (ultimaCompra.falhou) return { rotulo: 'Preço de Custo', valor: null, fonte: 'falhou' };
  const ultima = valorDeCusto(ultimaCompra.valor);
  if (ultima > 0) return { rotulo: 'Custo da última compra', valor: ultima, fonte: 'ultima_compra' };
  return { rotulo: 'Preço de Custo', valor: null, fonte: 'sem_custo' };
}
